<template>
  <div>
    <v-snackbar top :timeout="3000" v-model="snackbar">{{
      snackbarText
    }}</v-snackbar>
    <v-card class="d-flex flex-column">
      <v-card-title class="grid-close">
        <span class="headline"
          >{{ selectedItem ? "Editar" : "Agregar" }} {{ name }}</span
        >
        <v-btn
          style="right: 10px; top: 10px"
          icon
          color="primary"
          fab
          absolute
          @click="$emit('cancel')"
          v-if="!loading"
        >
          <v-icon dark>fa-times</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-container fluid>
          <v-form ref="form">
            <!-- player fields -->
            <v-row v-if="type == 'player'">
              <v-col cols="12" sm="12" md="12">
                <v-select
                  :items="playlists"
                  item-text="name"
                  rounded
                  filled
                  item-value="id"
                  :loading="loading"
                  required
                  :rules="[rules.required]"
                  v-model="item.playlist"
                  label="Lista de reproducción"
                  persistent-hint
                  hint="Las listas de reproducción sin archivos no se muestran."
                ></v-select>
              </v-col>
              <v-col>
                <v-select
                  :items="playerAdjustment"
                  item-text="name"
                  rounded
                  filled
                  item-value="value"
                  v-model="item.adjustment"
                  label="Ajustar contenido multimedia."
                >
                  <template v-slot:selection="data">
                    <v-list-item-title>{{ data.item.name }}</v-list-item-title>
                  </template>
                  <template v-slot:item="data">
                    <template>
                      <v-list-item-content>
                        <v-list-item-title>{{
                          data.item.name
                        }}</v-list-item-title>
                        <small>{{ data.item.description }}</small>
                      </v-list-item-content>
                    </template>
                  </template>
                </v-select>
              </v-col>
            </v-row>

            <!-- marquee fields -->
            <v-row v-if="type == 'marquee'">
              <v-col cols="12" sm="12" md="12">
                <v-textarea
                  v-model="item.text"
                  label="Texto a mostrar"
                  rounded
                  required
                  :rules="[rules.required]"
                  filled
                ></v-textarea>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  type="color"
                  v-model="item.backgroundColor"
                  required
                  :rules="[rules.required]"
                  label="Color del fondo"
                  rounded
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  type="color"
                  v-model="item.textColor"
                  required
                  :rules="[rules.required]"
                  label="Color de la letra"
                  rounded
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model.number="item.fontSize"
                  label="Tamaño de la letra"
                  rounded
                  type="number"
                  required
                  :rules="[rules.positive]"
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-select
                  :items="textSpeed"
                  item-text="name"
                  rounded
                  filled
                  required
                  :rules="[rules.required]"
                  item-value="value"
                  :loading="loading"
                  v-model="item.speed"
                  label="Velocidad de transición"
                ></v-select>
              </v-col>
            </v-row>
            <!-- notices fields -->
            <v-row v-if="type == 'notices'">
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="item.title"
                  label="Título del aviso"
                  rounded
                  required
                  :rules="[rules.required]"
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-textarea
                  v-model="item.body"
                  label="Contenido del aviso"
                  rounded
                  required
                  :rules="[rules.required]"
                  filled
                ></v-textarea>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  type="color"
                  v-model="item.backgroundColor"
                  required
                  :rules="[rules.required]"
                  label="Color del fondo"
                  rounded
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  type="color"
                  v-model="item.textColor"
                  required
                  :rules="[rules.required]"
                  label="Color de la letra"
                  rounded
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model.number="item.fontSizeTitle"
                  required
                  :rules="[rules.positive]"
                  label="Tamaño de la letra del título"
                  rounded
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model.number="item.fontSizeBody"
                  required
                  :rules="[rules.positive]"
                  label="Tamaño de la letra del contenido"
                  rounded
                  filled
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="6">
                <v-select
                  :items="textAlign"
                  item-text="name"
                  rounded
                  filled
                  required
                  :rules="[rules.required]"
                  item-value="value"
                  :loading="loading"
                  v-model="item.titleAlign"
                  label="Justificación del título"
                ></v-select>
              </v-col>

              <v-col cols="12" sm="6" md="6">
                <v-select
                  :items="textAlign"
                  item-text="name"
                  rounded
                  filled
                  required
                  :rules="[rules.required]"
                  item-value="value"
                  :loading="loading"
                  v-model="item.bodyAlign"
                  label="Justificación del contenido"
                ></v-select>
              </v-col>
            </v-row>
            <v-row v-if="type == 'time' && !loading">
              <time-component :conf="item.configuration" ref="timeRef" />
            </v-row>

            <v-row class="pa-0 ma-0">
              <v-col cols="12" sm="12" md="12">
                <v-row justify="end">
                  <v-btn
                    :loading="loading"
                    @click="selectedItem ? update() : add()"
                    color="btn-color"
                    >Guardar</v-btn
                  >
                </v-row>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { db, fb } from "@/firebase";
import timeComponent from "./components/time/index";

export default {
  name: "new-component",
  props: ["type", "selectedItem", "dimensions"],
  components: {
    timeComponent,
  },
  data() {
    return {
      snackbarText: "",
      snackbar: false,
      loading: true,
      rules: {
        required: (value) => !!value || "Obligatorio",
        positive: (value) => value > 0 || "Debe ingresar un número positivo.",
        min: (v) => (v && v.length >= 3) || "Mínimo 8 caracteres",
        email: (v) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(v) || "Correo Invalído";
        },
      },
      playlists: [],
      textAlign: [
        { name: "Justificado", value: 'justify' },
        { name: "Centrado", value: 'center' },
        { name: "Derecha", value: 'right' },
        { name: "Izquierda", value: 'left' },
      ],
      textSpeed: [
        { name: "Lento", value: "slow" },
        { name: "Medio", value: "medium" },
        { name: "Rápido", value: "fast" },
      ],
      playerAdjustment: [
        {
          name: "Contenedor",
          value: "contain",
          description:
            "La imagen mantiene su relación de aspecto, pero se cambia de tamaño para ajustarse a la dimensión dada.",
        },
        {
          name: "Rellenar",
          value: "fill",
          description:
            "La imagen cambia de tamaño para llenar la dimensión dada. Si es necesario, la imagen se estirará o aplastará para que se ajuste.",
        },
        {
          name: "Portada",
          value: "cover",
          description:
            "La imagen mantiene su relación de aspecto y ocupa la dimensión dada. La imagen se recortará para adaptarse.",
        },
      ],
      item: {
        width: 590,
        height: 334,
        x: 100,
        y: 100,
      },
    };
  },
  computed: {
    name() {
      let flag = this.type
        ? this.type
        : this.selectedItem
        ? this.selectedItem.type
        : "";

      switch (flag) {
        case "player":
          return "reproductor multimedia";
          break;
        case "weather":
          return "clima";
          break;
        case "marquee":
          return "cinta informativa";
          break;
        case "notices":
          return "aviso";
          break;
        case "time":
          return "hora";
          break;
        case "date":
          return "fecha";
          break;
        default:
          return "componente";
          break;
      }
    },
  },

  methods: {
    update() {
      if (this.$refs.form.validate()) {
        this.loading = true;

        switch (this.item.type) {
          case "time":
            this.item.configuration = this.$refs.timeRef.configuration;
            break;
        }

        this.$emit("updated", this.item);
      } else {
        this.snackbarText = "Debe completar todos los campos.";
        this.snackbar = true;
        return;
      }
    },
    async add() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.item.type = this.type;

        switch (this.item.type) {
          case "time":
            this.item.configuration = this.$refs.timeRef.configuration;
            break;
          case "player":
            this.item.adjustment = "fill";
            break;
          case "marquee":
            this.item.width = this.dimensions.width;
            this.item.height = 50;
            this.item.y = this.dimensions.height - 50;
            this.item.x = 0;
            break;

          default:
            break;
        }

        this.$emit("success", this.item);
      } else {
        this.snackbarText = "Debe completar todos los campos.";
        this.snackbar = true;
        return;
      }
    },
  },
  async mounted() {
    if (this.selectedItem)
      this.item = Object.assign({}, this.selectedItem.data);

    if (this.type == "player") {
      let groupId = this.$store.state.groupId;
      this.loading = true;
      await db
        .collection("playlists")
        .where("groupId", "==", groupId)
        .get()
        .then((response) => {
          response.forEach((item) => {
            let playlist = item.data();
            playlist.id = item.id;
            this.playlists.push(playlist);
          });
          this.playlists = this.playlists.filter(
            (item) => item.files.length > 0
          );
          this.loading = false;
        });
    } else {
      this.loading = false;
    }
  },
};
</script>

<style scoped>
input[type="color"] {
  height: 100px !important;
  min-height: 100px !important;
  max-height: 100px !important;
}
</style>